import css from "csstype";

const rowAttention: css.Properties = {
  backgroundColor: "#f8d7da",
};

const statusCell: css.Properties = {
  width: "260px",
  minWidth: "200px",
  maxWidth: "320px",
  verticalAlign: "top",
  boxSizing: "border-box",
};

const statusCellLayout: css.Properties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "4px",
  width: "100%",
  minWidth: 0,
};

const statusTopRow: css.Properties = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "6px",
  minWidth: 0,
  width: "100%",
};

const statusStack: css.Properties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "4px",
  width: "100%",
  minWidth: 0,
};

const actionsCell: css.Properties = {
  width: "56px",
  minWidth: "56px",
  maxWidth: "72px",
  verticalAlign: "middle",
  textAlign: "center",
  boxSizing: "border-box",
};

const actionsCellLayout: css.Properties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  minWidth: 0,
};

const decisionBadge: css.Properties = {
  flexShrink: 0,
};

const rejectionReasonCell: css.Properties = {
  width: "240px",
  minWidth: "180px",
  maxWidth: "260px",
  verticalAlign: "middle",
  boxSizing: "border-box",
};

const rejectionReasonText: css.Properties = {
  display: "block",
  maxWidth: "220px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const complianceIconTrigger: css.Properties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  cursor: "default",
  outline: "none",
};

const complianceIconConsistent: css.Properties = {
  color: "#0a7c00",
};

const complianceIconInconsistent: css.Properties = {
  color: "#a4262c",
};

const dialogContentWrapper: css.Properties = {
  marginTop: "12px",
};

const textarea: css.Properties = {
  width: "300px",
};

const validationError: css.Properties = {
  color: "#a4262c",
  marginTop: "8px",
};

const baselineStaleHint: css.Properties = {
  fontSize: "11px",
  color: "#805900",
  lineHeight: 1.2,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
};

const styles = {
  rowAttention,
  decisionBadge,
  rejectionReasonCell,
  rejectionReasonText,
  statusCell,
  statusCellLayout,
  statusTopRow,
  statusStack,
  actionsCell,
  actionsCellLayout,
  complianceIconTrigger,
  complianceIconConsistent,
  complianceIconInconsistent,
  dialogContentWrapper,
  textarea,
  validationError,
  baselineStaleHint,
};

export default styles;
